import axiosPost from '../axiosPost';

export const limitesGet = async (arg) => {
    const { params } = arg;
    const body = {
        "service": "CondicionAFIPLimiteGet",
        "params": params ? params : {}
    }
    
    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } 
    catch (err) {
        console.log(err)
    };
};